import { createSceneReducer } from 'reducers/reducers-util';
import reportsDataReducer from './reports.data';
import reportsUiReducer from './reports.ui';

export default createSceneReducer(reportsDataReducer, reportsUiReducer);
